export default __webpack_public_path__ + "static/media/costar-clone-three.aba747db.png";